// @flow

import { rem } from 'polished';
import cx from 'classnames';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Translate from 'client/components/translate';
import 'client/styles/ribbon.scss';

const defaultProps = {
  classes: { className: '' },
  hasUnderline: false,
  isCompactRibbon: false,
  using: {},
  wrapAround: false,
};

type Props = {
  classes: {
    className: string,
  },
  content: string,
  hasUnderline: boolean,
  isCompactRibbon: boolean,
  using: Object,
  wrapAround: boolean,
};

const CompactRibbonContainer = styled.div`
  && {
    .ribbon {
      font-size: ${rem(12)};
      line-height: ${rem(17)};
      min-width: ${rem(90)};
    }
    .ribbon.wrap-around {
      padding-left: 0.5rem;
      padding-right: ${rem(10)};
    }
    .ribbon:before {
      border-bottom-width: 1.05em;
      border-left-width: 1.05em;
      border-top-width: 1.05em;
    }
  }
`;

const StyledTranslate = styled(Translate)`
  border-bottom: ${props => (props.hasUnderline ? '1px' : '0')} dashed;
`;

class Ribbon extends PureComponent<Props> {
  static defaultProps = defaultProps;
  render() {
    const {
      content,
      wrapAround,
      classes: { className = '' },
      hasUnderline,
      isCompactRibbon,
      using,
    } = this.props;
    const RibbonContainer = isCompactRibbon ? CompactRibbonContainer : React.Fragment;
    return (
      <RibbonContainer>
        <div className={cx('ribbon', { 'wrap-around': wrapAround }, className)}>
          <StyledTranslate hasUnderline={hasUnderline} path={content} using={using} />
        </div>
      </RibbonContainer>
    );
  }
}

export default Ribbon;
